exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#googleReviews .loader {\n  border: 3px solid #043250;\n  border-right-color: transparent;\n  border-top-color: transparent;\n  height: 3em;\n  width: 3em;\n  margin: auto;\n  margin-top: 35%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-351a24be","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/global/googleReviews/googleReviews.component.scss
// module id = 226
// module chunks = 1